export const OpenDcCampaignType = {
    display: "DISPLAY",
    video: "VIDEO",
    socialVideo: "SOCIAL_VIDEO",
    socialStatic: "SOCIAL_STATIC",
} as const;
